export const SRHT_TAB_MANAGE = 'manage';
export const SRHT_TAB_CANDIDATE = 'candidate';
export const SRHT_TAB_INSTRUCTOR = 'instructor';
export const SRHT_TAB_EVALUATION = 'evaluation';

export function getVisibleSrhtTabs(permissions = {}) {
  const visibleTabs = [];

  if (permissions.canManageAdministration) {
    visibleTabs.push(SRHT_TAB_MANAGE);
  }

  visibleTabs.push(SRHT_TAB_CANDIDATE);

  if (permissions.canEditInstructorFeedback || permissions.canViewEvaluations) {
    visibleTabs.push(SRHT_TAB_INSTRUCTOR);
  }

  if (permissions.canViewEvaluations || permissions.canEditEvaluations) {
    visibleTabs.push(SRHT_TAB_EVALUATION);
  }

  return visibleTabs;
}